import { FC } from 'react';
import { Tooltip } from 'antd';
import cs from 'classnames';
import styles from '../index.module.less';
import IconFont from '@/common/components/Base/IconFont';

/** 国家维度-信息项 */
const Info: FC<{
  icon: string;
  num: string | number;
  unit: string;
  text: string;
  explain?: string;
  className?: string;
  labelSuffix?: any;
}> = ({
  icon,
  num,
  unit,
  text,
  explain,
  className,
  labelSuffix,
}) => {
  return (
    <div className={cs(styles.info, className)}>
      <div className={styles.infoLeftContent}>
        <div className={styles.infoNum}>
          <span className={styles.infoNumFont}>{num}</span>
          {unit && <span className={styles.infoUnit}>{unit}</span>}
        </div>
        <div className={styles.infoText}>
          <span>{text}</span>
          { labelSuffix }
          {explain && <Tooltip placement='right' title={explain}>
            <div className={cs(styles.explain)}>
              <IconFont iconHref='iconic_warning' style={{ width: '11px', height: '11px', color: '#999' }}/>
            </div>
          </Tooltip>}
        </div>
      </div>
      {
        icon && (
          <div className={styles.infoRightContent}>
            <IconFont
              className={styles.icon}
              iconHref={icon}></IconFont>
          </div>
        )
      }
    </div>
  );
};

export default Info;
